import { Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';

interface ITreatment {
  treatmentMethod: string;
}

export const Treatment = ({ treatmentMethod }: ITreatment) => {
  const isDesktop = useIsDesktop();

  return (
    <Typography
      variant='body6'
      sx={{
        p: isDesktop ? '8px 12px' : '6px 12px',
        color: '#1552E8',
        border: '1px solid',
        borderColor: '#E7EDFF',
        borderRadius: '48px',
      }}
    >
      {treatmentMethod}
    </Typography>
  );
};
